import { APIResponse, APIResponseDtoImpl } from '../../apiresponse';


export interface UpgradePackResponse extends APIResponse
{
}


export class UpgradePackResponseDtoImpl extends APIResponseDtoImpl implements UpgradePackResponse
{
   
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/tune/upgradepack/upgradepackresponse.tsx